import { useContext } from 'react';
import { ServicesContext } from '../Provider';

export const useServices = () => useContext(ServicesContext);
